import { useCallback, useState } from 'react'
import { Modal } from 'antd'

const useModal = () => {
  const [visible, setVisible] = useState(false)

  const render = useCallback(
    (props) => <Modal open={visible} onClose={() => setVisible(false)} {...props} />,
    [visible],
  )

  return {
    Modal: render,
    toggleModal: (value) => setVisible(value),
  }
}

export default useModal
